import React, { useState } from 'react';
import { useId } from "react-id-generator";
import FormRow from 'commons/components/FormFields/FormRow';
import MetsIcon from 'commons/components/MetsIcon';

interface PasswordFieldProps {
    className?: string,
    disabled?: boolean,
    description?: string,
    error?: string,
    id?: string,
    label: string,
    name: string,
    onChange: (e: React.ChangeEvent) => void,
    rowClassName?: string,
    touched?: boolean
}

function PasswordField(props: PasswordFieldProps) {

    const [showPassword, setShowPassword] = useState(false);
    const inputId = props.id ?? useId(1, "inputField-")[0];
    const inputRef = React.createRef<HTMLInputElement>();
    const inputProps = Object.assign({}, props);

    // Remove props not used by the HTML <input>
    delete inputProps.description;
    delete inputProps.error;
    delete inputProps.rowClassName;
    delete inputProps.touched;

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    return (
        <FormRow
            className={props.rowClassName}
            description={props.description}
            disabled={props.disabled}
            error={props.error}
            fieldIcon={
                showPassword ? <MetsIcon key="svg_eye_hide" name="svg_eye_hide" onClick={toggleShowPassword} className="input-field-password-icon" /> 
                            : <MetsIcon key="svg_eye" name="svg_eye" onClick={toggleShowPassword} className="input-field-password-icon" />
            }
            idPrefix={props.name}
            inputId={inputId}
            label={props.label}
            touched={props.touched}
            type="password">
                <input 
                    {...inputProps}
                    className={`input-field input-field-password ${props.className ? props.className : ''}`}
                    data-testid={inputId}
                    disabled={props.disabled}
                    id={inputId}
                    ref={inputRef}
                    type={showPassword ? "text" : "password"}
                />
        </FormRow>
    );

}

PasswordField.defaultProps = {
    disabled: false,
    touched: false
};

export default PasswordField;